import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe ser usado dentro de AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [credentials, setCredentials] = useState(null);
  const [loading, setLoading] = useState(true);

  // Cargar credenciales guardadas al iniciar
  useEffect(() => {
    const savedCredentials = localStorage.getItem('auth_credentials');
    if (savedCredentials) {
      try {
        const creds = JSON.parse(savedCredentials);
        setCredentials(creds);
        setIsAuthenticated(true);
      } catch (error) {
                localStorage.removeItem('auth_credentials');
      }
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      // Guardar credenciales
      const creds = { username, password };
      setCredentials(creds);
      setIsAuthenticated(true);
      localStorage.setItem('auth_credentials', JSON.stringify(creds));
      return { success: true };
    } catch (error) {
            return { success: false, error: error.message };
    }
  };

  const logout = () => {
    setCredentials(null);
    setIsAuthenticated(false);
    localStorage.removeItem('auth_credentials');
  };

  const getAuthHeader = () => {
    if (!credentials) return null;
    const token = btoa(`${credentials.username}:${credentials.password}`);
    return `Basic ${token}`;
  };

  const value = {
    isAuthenticated,
    credentials,
    login,
    logout,
    getAuthHeader,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};




